<script setup>
import GenericModal from './GenericModal.vue';
import { computed, ref } from 'vue';
import { downloadFile } from '@/plugins/utils/httpRequest.js'
import { usePortAllData } from '@/stores/portAllData';
import { storeToRefs } from 'pinia';

const store = usePortAllData()
const { getIsMobile } = storeToRefs(store)

const props = defineProps({
  featureProperties: {
    type: Object,
    default: () => {
      return {}
    }
  },
  propertyKey: {
    type: String,
    default: ''
  },
  static: {
    type: Boolean,
    default: false
  },
  url: {
    type: String,
    default: ''
  }
})

const modalActive = ref(false)
const type = ref(null)

const toggleModal = () => {
  modalActive.value = !modalActive.value
  if (!modalActive.value) {
    type.value = null
  }
}

const request = computed(() => {
  if (props.static) return props.url
  const token = localStorage.getItem('token')
  let req = `/wms?SERVICE=WMS&REQUEST=GetDocument&CELL_ID=${props.featureProperties.cell.split(' ')[0]}&FILE_NAME=${props.featureProperties[props.propertyKey]}`
  if (/.*\.(tif|tiff|TIF|TIFF)$/.test(props.featureProperties[props.propertyKey])) req += '&FORMAT=image/png'
  req += `&token=${token}`
  return req
})

const getDocument = (e) => {
  e.stopPropagation()
  let urlToTest
  if (props.static) urlToTest = props.url
  else urlToTest = props.featureProperties[props.propertyKey]

  if (/.*\.(ti(f)?f|png|jp(e)?g|gif|webp)$/i.test(urlToTest)) type.value = 'image'
  else if (/.*\.pdf$/i.test(urlToTest)) type.value = 'pdf'
  else if (/.*\.(t(e)?xt)$/i.test(urlToTest)) type.value = 'text'
  toggleModal()
}

const downloadPdf = async (e) => {
  e.stopPropagation()
  const token = localStorage.getItem('token')
  if (props.featureProperties.cell) {
    let req = `/wms?SERVICE=WMS&REQUEST=GetDocument&CELL_ID=${props.featureProperties.cell.split(' ')[0]}&FILE_NAME=${props.featureProperties[props.propertyKey]}`
    if (/.*\.(tif|tiff|TIF|TIFF)$/.test(props.featureProperties[props.propertyKey])) req += '&FORMAT=image/png'
    req += `&token=${token}`

    downloadFile(req, `${props.featureProperties[props.propertyKey]}`)
  } else if (props.url) {
    const filename = props.url.split('/').pop()
    downloadItem(props.url, filename)
  }
}

const downloadItem = (url, filename) => {
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.setAttribute('type', 'hidden')
  a.setAttribute('target', '_blank')
  document.body.appendChild(a)
  a.click()
  a.remove()
}
</script>

<template>
  <div class="buttons-document">
    <button type="button" @click="getDocument">
      <i class="icon-eye" />
    </button>
    <button v-if="!getIsMobile" type="button" @click="downloadPdf">
      <i class="icon-download-cloud" />
    </button>
  </div>
  <generic-modal :modal-active="modalActive" :type="type" :request="request" @close-modal="toggleModal" />
</template>